import {
  SET_LOADING_SETTINGS,
  GET_ALL_SETTINGS,
  ERROR_SETTINGS,
} from '../types';

const initialState = {
  isLoading: false,
  error: null,
  allRoles: {
    items: null,
    count: 0,
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADING_SETTINGS:
      return {
        ...state,
        isLoading: true,
      };

    case GET_ALL_SETTINGS:
      let { roles, roles_count } = action.payload;
      return {
        ...state,
        allRoles: {
          items: roles,
          count: roles_count,
        },
        isLoading: false,
      };

    case ERROR_SETTINGS:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    default:
      return state;
  }
};

export default reducer;
